import React from 'react'
import styled from 'styled-components'
import { Link, useHistory } from 'react-router-dom';

import { Button } from 'components'
import { motion } from 'framer-motion'

const Container = styled.div`
    min-height: calc(100vh - 3rem - 10rem - 10rem);
    /* border: 1px solid red; */
    display: grid;
    grid-template-rows: 50% 50%;
    grid-template-columns: 100%;
    padding: 0 1rem;
    justify-content: center;
    align-items: center;
    align-content: center;
`

const Title = styled.div`
    font-weight: bolder;
    font-size: 4rem;
    word-wrap: break-word;
    margin-bottom: 1rem;
    grid-row: 1;
    align-self: end;
    line-height: 1;
    text-align: center;
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    align-self: start;
`

const Subtitle = styled.div`
    font-size: 1.5rem;
    grid-row: 2;
    text-align: center;
    margin-bottom: 0.5rem;
    max-width: 50vw;
    @media (max-width: 600px) {
        max-width: 80vw;
    }
`

const Banner = props => {
    const history = useHistory();
    const buttonStyle = {
        backgroundColor: 'var(--focus-color)',
        width: 'fit-content',
        fontSize: '1rem',
        padding: '0.5rem',
        // fontWeight: 'bolder',
    }
    return (
        <Container>
            <Title>
                <motion.div initial={{y: 10, opacity: 0}} animate={{ scaleX: 1, y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: 'easeIn'}}>
                    Build simple complexities
                </motion.div>
            </Title>
            
            <Wrapper>
                <motion.div initial={{y: 10, opacity: 0}} animate={{ scaleX: 1, y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: 'easeIn', delay: 0.5 }}>
                    <Subtitle>Break projects into tasks, collborate with others and integrate apps to improve your workflow</Subtitle>
                </motion.div>

                <motion.div initial={{ y: 10, opacity: 0}} animate={{ scaleX: 1, y: 0, opacity: 1 }}
                    transition={{ duration: 0.5, ease: 'easeIn', delay: 1 }}>
                    <Button text='Get started' onSelect={() => history.push('register')} styles={buttonStyle}/>
                </motion.div>
            </Wrapper>
        </Container>
    )
}

export default Banner;